export default __webpack_public_path__ + "static/media/sofiapro-medium-webfont.825079d0.woff2";